export default __webpack_public_path__ + "0e0e4775c604a4bc96a9119d4fcc33be.png";